import { Component, EventEmitter, Input, Output } from "@angular/core";

import { Breadcrumb, BreadcrumbItem } from "./breadcrumb.type";

@Component({
   selector: "app-breadcrumb",
   templateUrl: "./breadcrumb.component.html",
   styleUrls: ["./breadcrumb.component.css"],
})
export class BreadcrumbComponent {
   @Input() breadcrumb: Breadcrumb;
   @Output() clickBreadcrumb = new EventEmitter<BreadcrumbItem>();

   constructor() {}

   /** Navigate to specified path. Do nothing if 'path' is falsy value. */
   protected onClickBreadcrumb($event: MouseEvent, breadcrumbItem: BreadcrumbItem) {
      $event.stopPropagation();
      this.clickBreadcrumb.emit(breadcrumbItem);
   }
}
